// extracted by mini-css-extract-plugin
module.exports = {"section":"Section-module--section--2nM98","dark":"Section-module--dark--15vxo","inner":"Section-module--inner--3CraM"};